import { stepsFullPath } from '../stepsPath';
import { TherapistFields } from '../util';

export const coveredFields: TherapistFields = [
  'modalities', 'therapies'
];
export const step4_2Path = "/4_2";
export const step4_2FullPath = `${stepsFullPath}${step4_2Path}`;